import { createContext, useContext } from 'react';

// Opening the help panel from anywhere (APP-DESIGN.md 10.1): the "?" in the rail, ⌘K, an error's
// "Report this problem", Settings → Your requests. The panel lives in the Shell; outside it (the
// sign-in pages) there is no panel and `open` is null.

export type RequestType = 'bug' | 'howto' | 'billing' | 'feature';

export type HelpView =
  | { kind: 'home'; query?: string }
  | { kind: 'form'; type: RequestType; prefill?: { subject?: string; body?: string; errorId?: string; assistantConversationId?: string } }
  | { kind: 'assistant'; question?: string; mode?: 'help' | 'books' }
  | { kind: 'request'; id: string }
  | { kind: 'article'; id: string }
  | { kind: 'whats-new' };

export const HelpContext = createContext<((view?: HelpView) => void) | null>(null);

/** Opens the help panel at a view, or null where there is no panel. */
export const useOpenHelp = () => useContext(HelpContext);

/** The build the app runs, for the context line of a request. Set by Vite from the CI commit. */
export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';

/** "Safari 18" and the like, from the user agent: enough to reproduce a problem, nothing more. */
export function browserName(ua: string): string {
  const pick = (re: RegExp, name: string) => { const m = re.exec(ua); return m ? `${name} ${m[1]}` : null; };
  return pick(/Edg\/(\d+)/, 'Edge')
    ?? pick(/Firefox\/(\d+)/, 'Firefox')
    ?? pick(/Chrome\/(\d+)/, 'Chrome')
    ?? pick(/Version\/(\d+)[\d.]* .*Safari/, 'Safari')
    ?? 'Unknown browser';
}
